/**
 * Status order for Kanban columns (matches task workflow).
 * Used when status enum ordering is not available from API.
 */
export const STATUS_ORDER = ['open', 'in-progress', 'completed', 'released'];

/**
 * Groups tasks by status for Kanban board columns.
 * @param {Array<{id: string, status?: string, [key: string]: any}>} tasks - Flat list of tasks
 * @returns {{ [statusKey: string]: Array }>} Object mapping status to task arrays
 */
export function groupByStatus(tasks) {
  if (!Array.isArray(tasks)) return {};

  const grouped = {};
  for (const task of tasks) {
    const status = (task.status || 'in-progress').toLowerCase().trim();
    if (!grouped[status]) grouped[status] = [];
    grouped[status].push(task);
  }

  return grouped;
}

/**
 * Returns status keys in display order for Kanban columns.
 * Always includes standard columns (open, in-progress, completed, released), then any extra statuses.
 * @param {{ [statusKey: string]: Array }} grouped - Result of groupByStatus
 * @returns {string[]} Ordered status keys
 */
export function getStatusColumnOrder(grouped) {
  const extra = Object.keys(grouped || {}).filter((s) => !STATUS_ORDER.includes(s));
  return [...STATUS_ORDER, ...extra];
}
